import {
  selectAmountInCart,
  type SelectPriceProps,
} from "~/features/productDetails/components/ProductSummary/PdpSummaryHelper";
import {
  getNetPrice,
  getRebatePercentage,
  getSurcharge,
  getTariff,
} from "~/domains/product/utils/productDescriptorUtils";
import { isSpecialPrice } from "~/features/productDetails/redux/productDetailsSelectors";
import { canSeeListPrice } from "~/utils/features";
import { Price as PriceV1, PriceType, RebateLabelType } from "~/domains/pricing/components/Price/v1/Price";
import { useSelector } from "react-redux";
import { isTariffSurchargeEnabled } from "~/features/cart/cart/utils/cartUtils";
import { type SxProps, type Theme } from "~/common/mui";

export interface NetPriceProps extends SelectPriceProps {
  netPriceClasses?: {
    root?: string | undefined;
    price?: string | undefined;
    label?: string | undefined;
  };
  netPriceOnRequestClasses?: {
    root?: string | undefined;
    price?: string | undefined;
    label?: string | undefined;
  };
  netPriceVariant?: PriceType;
  sx?: SxProps<Theme>;
}

export const NetPrice = (props: NetPriceProps) => {
  const classes = props.netPriceClasses;
  const classesOnRequest = props.netPriceOnRequestClasses ?? props.netPriceClasses;
  const totalQuantity = props.quantity + useSelector(selectAmountInCart(props));
  const price = getNetPrice({ ...props, totalQuantity });
  const surcharge = getSurcharge({ ...props, totalQuantity });
  const tariffSurcharge = isTariffSurchargeEnabled() && getTariff(props.product);
  const isSpecial = isSpecialPrice(props.product, props.packCode);
  const listPriceVisible = canSeeListPrice({ product: props.product, isSpecialPrice: isSpecial });
  const rebate = listPriceVisible
    ? getRebatePercentage({
        product: props.product,
        packCode: props.packCode,
        totalQuantity: totalQuantity,
      })
    : null;
  const clss = !price?.value || price?.value <= 0 ? classesOnRequest : classes;

  return (
    <PriceV1
      // @ts-ignore - TODO - Fix later FFS.
      variant={props.netPriceVariant || PriceType.ProductNetPrice}
      price={price}
      rebateVariant={RebateLabelType.Full}
      rebateValue={rebate}
      isSubscription={price?.isSubscription ?? false}
      isSpecialPrice={isSpecial}
      unit={price?.unit ?? 1}
      classes={clss}
      includesSurcharge={surcharge > 0}
      tariffSurcharge={tariffSurcharge}
      sx={props.sx}
    />
  );
};
